// Reto de doble factor pendiente entre la contraseña y el código: {token, status, method, email_hint}.
// WHY: va en sessionStorage y no en localStorage.user porque el guard del router trata
// "user" como sesión abierta (y lee user.me.phone, que aquí no existe).
const KEY = 'two_factor';

export const twoFactorChallenge = {
  save(challenge) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(challenge));
    } catch (e) {
      // Sin sessionStorage (modo privado estricto) el reto solo vive en esta navegación.
    }
  },
  get() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY));
    } catch (e) {
      return null;
    }
  },
  update(changes) {
    const current = this.get();
    if (current) {
      this.save(Object.assign({}, current, changes));
    }
  },
  clear() {
    try {
      sessionStorage.removeItem(KEY);
    } catch (e) {
      // nada que limpiar
    }
  }
};
